export default function Customers(props){
    return <div className="customer-card">
<img src={props.data.img} alt="customerImage"/>
    </div>
}